<template>
    <a
        class="md-partner partner-logo"
        v-if="partner.href"
        :href="partner.href"
        target="_blank"
        rel="noopener noreferrer"
    >
        <site-img
            class="partner-img"
            :src="partner.logoUrl"
            @load="handleLoad"
            dir="height"
            :size="256"
            :alt="partner.label"
            :lazy="false"
        ></site-img>
    </a>
    <site-img
        v-else
        class="md-partner partner-logo partner-img"
        :src="partner.logoUrl"
        @load="handleLoad"
        dir="height"
        :size="256"
        :alt="partner.label"
        :lazy="false"
    ></site-img>
</template>

<script>
export default {
    emits: ['load'],
    name: 'partner-logo',
    props: {
        partner: {
            type: Object
        }
    },
    methods: {
        handleLoad() {
            this.$emit('load', true);
        }
    }
};
</script>

<style lang="scss">
.md-partner.partner-logo {
    &.partner-img,
    .partner-img {
        height: 60px;
    }
}
</style>
